var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 3.8C2.94934 3.8 3.8 2.94934 3.8 1.9C3.8 0.850659 2.94934 0 1.9 0C0.850659 0 0 0.850659 0 1.9C0 2.94934 0.850659 3.8 1.9 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 3.8C27.6493 3.8 28.5 2.94934 28.5 1.9C28.5 0.850659 27.6493 0 26.6 0C25.5507 0 24.7 0.850659 24.7 1.9C24.7 2.94934 25.5507 3.8 26.6 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 3.8C52.3493 3.8 53.2 2.94934 53.2 1.9C53.2 0.850659 52.3493 0 51.3 0C50.2507 0 49.4 0.850659 49.4 1.9C49.4 2.94934 50.2507 3.8 51.3 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 28.5C2.94934 28.5 3.8 27.6493 3.8 26.6C3.8 25.5507 2.94934 24.7 1.9 24.7C0.850659 24.7 0 25.5507 0 26.6C0 27.6493 0.850659 28.5 1.9 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 28.5C27.6493 28.5 28.5 27.6493 28.5 26.6C28.5 25.5507 27.6493 24.7 26.6 24.7C25.5507 24.7 24.7 25.5507 24.7 26.6C24.7 27.6493 25.5507 28.5 26.6 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 28.5C52.3493 28.5 53.2 27.6493 53.2 26.6C53.2 25.5507 52.3493 24.7 51.3 24.7C50.2507 24.7 49.4 25.5507 49.4 26.6C49.4 27.6493 50.2507 28.5 51.3 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 53.2C2.94934 53.2 3.8 52.3493 3.8 51.3C3.8 50.2507 2.94934 49.4 1.9 49.4C0.850659 49.4 0 50.2507 0 51.3C0 52.3493 0.850659 53.2 1.9 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 53.2C27.6493 53.2 28.5 52.3493 28.5 51.3C28.5 50.2507 27.6493 49.4 26.6 49.4C25.5507 49.4 24.7 50.2507 24.7 51.3C24.7 52.3493 25.5507 53.2 26.6 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.2C52.3493 53.2 53.2 52.3493 53.2 51.3C53.2 50.2507 52.3493 49.4 51.3 49.4C50.2507 49.4 49.4 50.2507 49.4 51.3C49.4 52.3493 50.2507 53.2 51.3 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 77.8C2.94934 77.8 3.8 76.9493 3.8 75.9C3.8 74.8507 2.94934 74 1.9 74C0.850659 74 0 74.8507 0 75.9C0 76.9493 0.850659 77.8 1.9 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 77.8C27.6493 77.8 28.5 76.9493 28.5 75.9C28.5 74.8507 27.6493 74 26.6 74C25.5507 74 24.7 74.8507 24.7 75.9C24.7 76.9493 25.5507 77.8 26.6 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 77.8C52.3493 77.8 53.2 76.9493 53.2 75.9C53.2 74.8507 52.3493 74 51.3 74C50.2507 74 49.4 74.8507 49.4 75.9C49.4 76.9493 50.2507 77.8 51.3 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 102.5C2.94934 102.5 3.8 101.649 3.8 100.6C3.8 99.5507 2.94934 98.7 1.9 98.7C0.850659 98.7 0 99.5507 0 100.6C0 101.649 0.850659 102.5 1.9 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 102.5C27.6493 102.5 28.5 101.649 28.5 100.6C28.5 99.5507 27.6493 98.7 26.6 98.7C25.5507 98.7 24.7 99.5507 24.7 100.6C24.7 101.649 25.5507 102.5 26.6 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 102.5C52.3493 102.5 53.2 101.649 53.2 100.6C53.2 99.5507 52.3493 98.7 51.3 98.7C50.2507 98.7 49.4 99.5507 49.4 100.6C49.4 101.649 50.2507 102.5 51.3 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 127.2C2.94934 127.2 3.8 126.349 3.8 125.3C3.8 124.251 2.94934 123.4 1.9 123.4C0.850659 123.4 0 124.251 0 125.3C0 126.349 0.850659 127.2 1.9 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 127.2C27.6493 127.2 28.5 126.349 28.5 125.3C28.5 124.251 27.6493 123.4 26.6 123.4C25.5507 123.4 24.7 124.251 24.7 125.3C24.7 126.349 25.5507 127.2 26.6 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 127.2C52.3493 127.2 53.2 126.349 53.2 125.3C53.2 124.251 52.3493 123.4 51.3 123.4C50.2507 123.4 49.4 124.251 49.4 125.3C49.4 126.349 50.2507 127.2 51.3 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 151.8C2.94934 151.8 3.8 150.949 3.8 149.9C3.8 148.851 2.94934 148 1.9 148C0.850659 148 0 148.851 0 149.9C0 150.949 0.850659 151.8 1.9 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 151.8C27.6493 151.8 28.5 150.949 28.5 149.9C28.5 148.851 27.6493 148 26.6 148C25.5507 148 24.7 148.851 24.7 149.9C24.7 150.949 25.5507 151.8 26.6 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 151.8C52.3493 151.8 53.2 150.949 53.2 149.9C53.2 148.851 52.3493 148 51.3 148C50.2507 148 49.4 148.851 49.4 149.9C49.4 150.949 50.2507 151.8 51.3 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 176.5C2.94934 176.5 3.8 175.649 3.8 174.6C3.8 173.551 2.94934 172.7 1.9 172.7C0.850659 172.7 0 173.551 0 174.6C0 175.649 0.850659 176.5 1.9 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 176.5C27.6493 176.5 28.5 175.649 28.5 174.6C28.5 173.551 27.6493 172.7 26.6 172.7C25.5507 172.7 24.7 173.551 24.7 174.6C24.7 175.649 25.5507 176.5 26.6 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 176.5C52.3493 176.5 53.2 175.649 53.2 174.6C53.2 173.551 52.3493 172.7 51.3 172.7C50.2507 172.7 49.4 173.551 49.4 174.6C49.4 175.649 50.2507 176.5 51.3 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 201.2C2.94934 201.2 3.8 200.349 3.8 199.3C3.8 198.251 2.94934 197.4 1.9 197.4C0.850659 197.4 0 198.251 0 199.3C0 200.349 0.850659 201.2 1.9 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 201.2C27.6493 201.2 28.5 200.349 28.5 199.3C28.5 198.251 27.6493 197.4 26.6 197.4C25.5507 197.4 24.7 198.251 24.7 199.3C24.7 200.349 25.5507 201.2 26.6 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 201.2C52.3493 201.2 53.2 200.349 53.2 199.3C53.2 198.251 52.3493 197.4 51.3 197.4C50.2507 197.4 49.4 198.251 49.4 199.3C49.4 200.349 50.2507 201.2 51.3 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 225.8C2.94934 225.8 3.8 224.949 3.8 223.9C3.8 222.851 2.94934 222 1.9 222C0.850659 222 0 222.851 0 223.9C0 224.949 0.850659 225.8 1.9 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 225.8C27.6493 225.8 28.5 224.949 28.5 223.9C28.5 222.851 27.6493 222 26.6 222C25.5507 222 24.7 222.851 24.7 223.9C24.7 224.949 25.5507 225.8 26.6 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 225.8C52.3493 225.8 53.2 224.949 53.2 223.9C53.2 222.851 52.3493 222 51.3 222C50.2507 222 49.4 222.851 49.4 223.9C49.4 224.949 50.2507 225.8 51.3 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 3.8C76.9493 3.8 77.8 2.94934 77.8 1.9C77.8 0.850659 76.9493 0 75.9 0C74.8507 0 74 0.850659 74 1.9C74 2.94934 74.8507 3.8 75.9 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 3.8C101.649 3.8 102.5 2.94934 102.5 1.9C102.5 0.850659 101.649 0 100.6 0C99.5507 0 98.7 0.850659 98.7 1.9C98.7 2.94934 99.5507 3.8 100.6 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 28.5C76.9493 28.5 77.8 27.6493 77.8 26.6C77.8 25.5507 76.9493 24.7 75.9 24.7C74.8507 24.7 74 25.5507 74 26.6C74 27.6493 74.8507 28.5 75.9 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 28.5C101.649 28.5 102.5 27.6493 102.5 26.6C102.5 25.5507 101.649 24.7 100.6 24.7C99.5507 24.7 98.7 25.5507 98.7 26.6C98.7 27.6493 99.5507 28.5 100.6 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 53.2C76.9493 53.2 77.8 52.3493 77.8 51.3C77.8 50.2507 76.9493 49.4 75.9 49.4C74.8507 49.4 74 50.2507 74 51.3C74 52.3493 74.8507 53.2 75.9 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 53.2C101.649 53.2 102.5 52.3493 102.5 51.3C102.5 50.2507 101.649 49.4 100.6 49.4C99.5507 49.4 98.7 50.2507 98.7 51.3C98.7 52.3493 99.5507 53.2 100.6 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 77.8C76.9493 77.8 77.8 76.9493 77.8 75.9C77.8 74.8507 76.9493 74 75.9 74C74.8507 74 74 74.8507 74 75.9C74 76.9493 74.8507 77.8 75.9 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 77.8C101.649 77.8 102.5 76.9493 102.5 75.9C102.5 74.8507 101.649 74 100.6 74C99.5507 74 98.7 74.8507 98.7 75.9C98.7 76.9493 99.5507 77.8 100.6 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 102.5C76.9493 102.5 77.8 101.649 77.8 100.6C77.8 99.5507 76.9493 98.7 75.9 98.7C74.8507 98.7 74 99.5507 74 100.6C74 101.649 74.8507 102.5 75.9 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 102.5C101.649 102.5 102.5 101.649 102.5 100.6C102.5 99.5507 101.649 98.7 100.6 98.7C99.5507 98.7 98.7 99.5507 98.7 100.6C98.7 101.649 99.5507 102.5 100.6 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 127.2C76.9493 127.2 77.8 126.349 77.8 125.3C77.8 124.251 76.9493 123.4 75.9 123.4C74.8507 123.4 74 124.251 74 125.3C74 126.349 74.8507 127.2 75.9 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 127.2C101.649 127.2 102.5 126.349 102.5 125.3C102.5 124.251 101.649 123.4 100.6 123.4C99.5507 123.4 98.7 124.251 98.7 125.3C98.7 126.349 99.5507 127.2 100.6 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 151.8C76.9493 151.8 77.8 150.949 77.8 149.9C77.8 148.851 76.9493 148 75.9 148C74.8507 148 74 148.851 74 149.9C74 150.949 74.8507 151.8 75.9 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 151.8C101.649 151.8 102.5 150.949 102.5 149.9C102.5 148.851 101.649 148 100.6 148C99.5507 148 98.7 148.851 98.7 149.9C98.7 150.949 99.5507 151.8 100.6 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 176.5C76.9493 176.5 77.8 175.649 77.8 174.6C77.8 173.551 76.9493 172.7 75.9 172.7C74.8507 172.7 74 173.551 74 174.6C74 175.649 74.8507 176.5 75.9 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 176.5C101.649 176.5 102.5 175.649 102.5 174.6C102.5 173.551 101.649 172.7 100.6 172.7C99.5507 172.7 98.7 173.551 98.7 174.6C98.7 175.649 99.5507 176.5 100.6 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 201.2C76.9493 201.2 77.8 200.349 77.8 199.3C77.8 198.251 76.9493 197.4 75.9 197.4C74.8507 197.4 74 198.251 74 199.3C74 200.349 74.8507 201.2 75.9 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 201.2C101.649 201.2 102.5 200.349 102.5 199.3C102.5 198.251 101.649 197.4 100.6 197.4C99.5507 197.4 98.7 198.251 98.7 199.3C98.7 200.349 99.5507 201.2 100.6 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 225.8C76.9493 225.8 77.8 224.949 77.8 223.9C77.8 222.851 76.9493 222 75.9 222C74.8507 222 74 222.851 74 223.9C74 224.949 74.8507 225.8 75.9 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6 225.8C101.649 225.8 102.5 224.949 102.5 223.9C102.5 222.851 101.649 222 100.6 222C99.5507 222 98.7 222.851 98.7 223.9C98.7 224.949 99.5507 225.8 100.6 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 3.8C126.349 3.8 127.2 2.94934 127.2 1.9C127.2 0.850659 126.349 0 125.3 0C124.251 0 123.4 0.850659 123.4 1.9C123.4 2.94934 124.251 3.8 125.3 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 3.8C150.949 3.8 151.8 2.94934 151.8 1.9C151.8 0.850659 150.949 0 149.9 0C148.851 0 148 0.850659 148 1.9C148 2.94934 148.851 3.8 149.9 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 3.8C175.649 3.8 176.5 2.94934 176.5 1.9C176.5 0.850659 175.649 0 174.6 0C173.551 0 172.7 0.850659 172.7 1.9C172.7 2.94934 173.551 3.8 174.6 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 28.5C126.349 28.5 127.2 27.6493 127.2 26.6C127.2 25.5507 126.349 24.7 125.3 24.7C124.251 24.7 123.4 25.5507 123.4 26.6C123.4 27.6493 124.251 28.5 125.3 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 28.5C150.949 28.5 151.8 27.6493 151.8 26.6C151.8 25.5507 150.949 24.7 149.9 24.7C148.851 24.7 148 25.5507 148 26.6C148 27.6493 148.851 28.5 149.9 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 28.5C175.649 28.5 176.5 27.6493 176.5 26.6C176.5 25.5507 175.649 24.7 174.6 24.7C173.551 24.7 172.7 25.5507 172.7 26.6C172.7 27.6493 173.551 28.5 174.6 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 53.2C126.349 53.2 127.2 52.3493 127.2 51.3C127.2 50.2507 126.349 49.4 125.3 49.4C124.251 49.4 123.4 50.2507 123.4 51.3C123.4 52.3493 124.251 53.2 125.3 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 53.2C150.949 53.2 151.8 52.3493 151.8 51.3C151.8 50.2507 150.949 49.4 149.9 49.4C148.851 49.4 148 50.2507 148 51.3C148 52.3493 148.851 53.2 149.9 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 53.2C175.649 53.2 176.5 52.3493 176.5 51.3C176.5 50.2507 175.649 49.4 174.6 49.4C173.551 49.4 172.7 50.2507 172.7 51.3C172.7 52.3493 173.551 53.2 174.6 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 77.8C126.349 77.8 127.2 76.9493 127.2 75.9C127.2 74.8507 126.349 74 125.3 74C124.251 74 123.4 74.8507 123.4 75.9C123.4 76.9493 124.251 77.8 125.3 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 77.8C150.949 77.8 151.8 76.9493 151.8 75.9C151.8 74.8507 150.949 74 149.9 74C148.851 74 148 74.8507 148 75.9C148 76.9493 148.851 77.8 149.9 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 77.8C175.649 77.8 176.5 76.9493 176.5 75.9C176.5 74.8507 175.649 74 174.6 74C173.551 74 172.7 74.8507 172.7 75.9C172.7 76.9493 173.551 77.8 174.6 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 102.5C126.349 102.5 127.2 101.649 127.2 100.6C127.2 99.5507 126.349 98.7 125.3 98.7C124.251 98.7 123.4 99.5507 123.4 100.6C123.4 101.649 124.251 102.5 125.3 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 102.5C150.949 102.5 151.8 101.649 151.8 100.6C151.8 99.5507 150.949 98.7 149.9 98.7C148.851 98.7 148 99.5507 148 100.6C148 101.649 148.851 102.5 149.9 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 102.5C175.649 102.5 176.5 101.649 176.5 100.6C176.5 99.5507 175.649 98.7 174.6 98.7C173.551 98.7 172.7 99.5507 172.7 100.6C172.7 101.649 173.551 102.5 174.6 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 127.2C126.349 127.2 127.2 126.349 127.2 125.3C127.2 124.251 126.349 123.4 125.3 123.4C124.251 123.4 123.4 124.251 123.4 125.3C123.4 126.349 124.251 127.2 125.3 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 127.2C150.949 127.2 151.8 126.349 151.8 125.3C151.8 124.251 150.949 123.4 149.9 123.4C148.851 123.4 148 124.251 148 125.3C148 126.349 148.851 127.2 149.9 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 127.2C175.649 127.2 176.5 126.349 176.5 125.3C176.5 124.251 175.649 123.4 174.6 123.4C173.551 123.4 172.7 124.251 172.7 125.3C172.7 126.349 173.551 127.2 174.6 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 151.8C126.349 151.8 127.2 150.949 127.2 149.9C127.2 148.851 126.349 148 125.3 148C124.251 148 123.4 148.851 123.4 149.9C123.4 150.949 124.251 151.8 125.3 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 151.8C150.949 151.8 151.8 150.949 151.8 149.9C151.8 148.851 150.949 148 149.9 148C148.851 148 148 148.851 148 149.9C148 150.949 148.851 151.8 149.9 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 151.8C175.649 151.8 176.5 150.949 176.5 149.9C176.5 148.851 175.649 148 174.6 148C173.551 148 172.7 148.851 172.7 149.9C172.7 150.949 173.551 151.8 174.6 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 176.5C126.349 176.5 127.2 175.649 127.2 174.6C127.2 173.551 126.349 172.7 125.3 172.7C124.251 172.7 123.4 173.551 123.4 174.6C123.4 175.649 124.251 176.5 125.3 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 176.5C150.949 176.5 151.8 175.649 151.8 174.6C151.8 173.551 150.949 172.7 149.9 172.7C148.851 172.7 148 173.551 148 174.6C148 175.649 148.851 176.5 149.9 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 176.5C175.649 176.5 176.5 175.649 176.5 174.6C176.5 173.551 175.649 172.7 174.6 172.7C173.551 172.7 172.7 173.551 172.7 174.6C172.7 175.649 173.551 176.5 174.6 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 201.2C126.349 201.2 127.2 200.349 127.2 199.3C127.2 198.251 126.349 197.4 125.3 197.4C124.251 197.4 123.4 198.251 123.4 199.3C123.4 200.349 124.251 201.2 125.3 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 201.2C150.949 201.2 151.8 200.349 151.8 199.3C151.8 198.251 150.949 197.4 149.9 197.4C148.851 197.4 148 198.251 148 199.3C148 200.349 148.851 201.2 149.9 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 201.2C175.649 201.2 176.5 200.349 176.5 199.3C176.5 198.251 175.649 197.4 174.6 197.4C173.551 197.4 172.7 198.251 172.7 199.3C172.7 200.349 173.551 201.2 174.6 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 225.8C126.349 225.8 127.2 224.949 127.2 223.9C127.2 222.851 126.349 222 125.3 222C124.251 222 123.4 222.851 123.4 223.9C123.4 224.949 124.251 225.8 125.3 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 225.8C150.949 225.8 151.8 224.949 151.8 223.9C151.8 222.851 150.949 222 149.9 222C148.851 222 148 222.851 148 223.9C148 224.949 148.851 225.8 149.9 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6 225.8C175.649 225.8 176.5 224.949 176.5 223.9C176.5 222.851 175.649 222 174.6 222C173.551 222 172.7 222.851 172.7 223.9C172.7 224.949 173.551 225.8 174.6 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 3.8C200.349 3.8 201.2 2.94934 201.2 1.9C201.2 0.850659 200.349 0 199.3 0C198.251 0 197.4 0.850659 197.4 1.9C197.4 2.94934 198.251 3.8 199.3 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 3.8C224.949 3.8 225.8 2.94934 225.8 1.9C225.8 0.850659 224.949 0 223.9 0C222.851 0 222 0.850659 222 1.9C222 2.94934 222.851 3.8 223.9 3.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 28.5C200.349 28.5 201.2 27.6493 201.2 26.6C201.2 25.5507 200.349 24.7 199.3 24.7C198.251 24.7 197.4 25.5507 197.4 26.6C197.4 27.6493 198.251 28.5 199.3 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 28.5C224.949 28.5 225.8 27.6493 225.8 26.6C225.8 25.5507 224.949 24.7 223.9 24.7C222.851 24.7 222 25.5507 222 26.6C222 27.6493 222.851 28.5 223.9 28.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 53.2C200.349 53.2 201.2 52.3493 201.2 51.3C201.2 50.2507 200.349 49.4 199.3 49.4C198.251 49.4 197.4 50.2507 197.4 51.3C197.4 52.3493 198.251 53.2 199.3 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 53.2C224.949 53.2 225.8 52.3493 225.8 51.3C225.8 50.2507 224.949 49.4 223.9 49.4C222.851 49.4 222 50.2507 222 51.3C222 52.3493 222.851 53.2 223.9 53.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 77.8C200.349 77.8 201.2 76.9493 201.2 75.9C201.2 74.8507 200.349 74 199.3 74C198.251 74 197.4 74.8507 197.4 75.9C197.4 76.9493 198.251 77.8 199.3 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 77.8C224.949 77.8 225.8 76.9493 225.8 75.9C225.8 74.8507 224.949 74 223.9 74C222.851 74 222 74.8507 222 75.9C222 76.9493 222.851 77.8 223.9 77.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 102.5C200.349 102.5 201.2 101.649 201.2 100.6C201.2 99.5507 200.349 98.7 199.3 98.7C198.251 98.7 197.4 99.5507 197.4 100.6C197.4 101.649 198.251 102.5 199.3 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 102.5C224.949 102.5 225.8 101.649 225.8 100.6C225.8 99.5507 224.949 98.7 223.9 98.7C222.851 98.7 222 99.5507 222 100.6C222 101.649 222.851 102.5 223.9 102.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 127.2C200.349 127.2 201.2 126.349 201.2 125.3C201.2 124.251 200.349 123.4 199.3 123.4C198.251 123.4 197.4 124.251 197.4 125.3C197.4 126.349 198.251 127.2 199.3 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 127.2C224.949 127.2 225.8 126.349 225.8 125.3C225.8 124.251 224.949 123.4 223.9 123.4C222.851 123.4 222 124.251 222 125.3C222 126.349 222.851 127.2 223.9 127.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 151.8C200.349 151.8 201.2 150.949 201.2 149.9C201.2 148.851 200.349 148 199.3 148C198.251 148 197.4 148.851 197.4 149.9C197.4 150.949 198.251 151.8 199.3 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 151.8C224.949 151.8 225.8 150.949 225.8 149.9C225.8 148.851 224.949 148 223.9 148C222.851 148 222 148.851 222 149.9C222 150.949 222.851 151.8 223.9 151.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 176.5C200.349 176.5 201.2 175.649 201.2 174.6C201.2 173.551 200.349 172.7 199.3 172.7C198.251 172.7 197.4 173.551 197.4 174.6C197.4 175.649 198.251 176.5 199.3 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 176.5C224.949 176.5 225.8 175.649 225.8 174.6C225.8 173.551 224.949 172.7 223.9 172.7C222.851 172.7 222 173.551 222 174.6C222 175.649 222.851 176.5 223.9 176.5Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 201.2C200.349 201.2 201.2 200.349 201.2 199.3C201.2 198.251 200.349 197.4 199.3 197.4C198.251 197.4 197.4 198.251 197.4 199.3C197.4 200.349 198.251 201.2 199.3 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 201.2C224.949 201.2 225.8 200.349 225.8 199.3C225.8 198.251 224.949 197.4 223.9 197.4C222.851 197.4 222 198.251 222 199.3C222 200.349 222.851 201.2 223.9 201.2Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 225.8C200.349 225.8 201.2 224.949 201.2 223.9C201.2 222.851 200.349 222 199.3 222C198.251 222 197.4 222.851 197.4 223.9C197.4 224.949 198.251 225.8 199.3 225.8Z",
    fill: "#71869d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 225.8C224.949 225.8 225.8 224.949 225.8 223.9C225.8 222.851 224.949 222 223.9 222C222.851 222 222 222.851 222 223.9C222 224.949 222.851 225.8 223.9 225.8Z",
    fill: "#71869d"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225.9,
    height: 225.9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.43bed5f74274338e26d16286dc7756c8.svg";
export { ForwardRef as ReactComponent };